import { LoaderLifestyleHorizontal } from '@collinsonx/design-system';
import useLocale from 'hooks/useLocale';
import { RenderElement } from 'types/components';

interface CustomLazyLoadProps {
  children?: RenderElement;
  hideIf?: boolean;
  loader?: RenderElement;
  loading?: boolean;
  wrapper?: React.FC<{ children: RenderElement }>;
}

export default function LazyLoad({
  children = null,
  hideIf = false,
  loader = <LoaderLifestyleHorizontal />,
  loading = true,
  wrapper: Wrapper,
}: Readonly<CustomLazyLoadProps>) {
  const translations = useLocale();

  if (hideIf) return null;

  const componentToRender = Wrapper ? <Wrapper>{children}</Wrapper> : children;
  const loaderToRender = Wrapper ? <Wrapper>{loader}</Wrapper> : loader;

  const componentState = loading ? (
    <div aria-label={translations.generic.labels.loading}>{loaderToRender}</div>
  ) : (
    componentToRender
  );

  return componentState as RenderElement;
}
